import { IconButton } from "@nova/component-btn"
import { QuestionProps } from "./ChecklistQuestionTypes"
import * as Icons from "@nova/component-icons"
import { ToggleSwitch } from "@nova/component-toggle-switch"

export const ChecklistUserSelectQuestion = ({
    spec,
    questionControls,
    autoFocus = false,
}: QuestionProps<"user-select">) => {
    return (
        <input
            className="bg-gray-700 rounded-lg text-gray-0 border-0"
            value={spec.question}
            onChange={(e) =>
                questionControls.editQuestion(spec.id, { ...spec, question: e.target.value })
            }
            placeholder="Enter your question"
            autoFocus={autoFocus}
        />
    )
}

export const ChecklistUserSelectFooter = ({
    questionControls,
    spec,
}: QuestionProps<"user-select">) => {
    return (
        <div className="px-8 py-4 flex items-center justify-between gap-4">
            <div className="flex items-center gap-2">
                <ToggleSwitch
                    isToggled={spec.isRequired}
                    setIsToggled={(v) =>
                        questionControls.editQuestion(spec.id, {
                            ...spec,
                            isRequired: v,
                        })
                    }
                />
                <div>Required</div>
            </div>
            <IconButton
                onClick={() => {
                    questionControls.deleteQuestion(spec.id)
                }}
            >
                <Icons.Icon
                    Icon={Icons.Trash}
                    className="text-gray-400 hover:text-red-500 transition-colors"
                />
            </IconButton>
        </div>
    )
}
